import React, { Component } from "react";

class Icon extends Component {
	render() {

        const {icon, style} = this.props;
		return (
			<React.Fragment>
                <img src={'https://pykin.in/assets/svg_icons/'+ icon + '.svg'} style={style ? style : {height: '25px', width: '25px'}} />
			</React.Fragment>
		);
	}
}

export default Icon;
